import COS from 'cos-js-sdk-v5'
import { Toast } from 'vant'
import { getVideoAuthorization } from '@/api/recruitment'
import { isApp, isAndroidApp, isIosApp } from './cookie'

export function goback() {
  setTimeout(() => {
    if (isApp()) {
      let options = null
      if (isIosApp()) {
        options = {
          targetClass: 'self',
          methodName: 'goBack',
          methodType: '0',
          parm: []
        }
        const str = JSON.stringify(options)
        window.app &&
          window.app.jsNavtiveHandle &&
          window.app.jsNavtiveHandle(str)
      } else if (isAndroidApp()) {
        window.localjs.goBackDefault()
      }
    } else {
      history.go(-1)
    }
  }, 1000)
}

export function isValidDate(date: Date) {
  return date instanceof Date && !isNaN(date.getTime())
}

export const debounce = (fn: any, delay = 500) => {
  let timer: any = null
  return (...rest: any[]) => {
    if (timer) {
      return
    }
    fn(...rest)
    timer = setTimeout(() => {
      timer = null
    }, delay)
  }
}

export function memo(fn: any) {
  const cache: any = {}
  return (...rest: any[]) => {
    return (
      cache[JSON.stringify(rest)] || (cache[JSON.stringify(rest)] = fn(...rest))
    )
  }
}

const cosConfig = {
  bucket: 'cardvideo-1251601690' /* 存储桶，必须字段 */,
  region: 'ap-shanghai' /* 存储桶所在地域，例如ap-beijing，必须字段 */
}

const cos = new COS({
  getAuthorization: async function (options, callback: any) {
    try {
      // 异步获取临时密钥
      const { data } = await getVideoAuthorization(cosConfig)
      const {
        credentials: { tmpSecretId, tmpSecretKey, sessionToken },
        expiredTime
      } = data
      callback({
        TmpSecretId: tmpSecretId,
        TmpSecretKey: tmpSecretKey,
        XCosSecurityToken: sessionToken,
        ExpiredTime: expiredTime
      })
    } catch (error) {
      console.log(error)
    }
  }
})

export function uploadVideo({ fileName, file }: any) {
  return new Promise((resolve, reject) => {
    cos.putObject(
      {
        Bucket: cosConfig.bucket /* 存储桶，必须字段 */,
        Region: cosConfig.region /* 存储桶所在地域，例如ap-beijing，必须字段 */,
        Key: fileName /* 存储在桶里的对象键（请注意唯一性不然在删除的时候会找到相同的key），必须字段 */,
        Body: file, // 上传文件对象
        onProgress: function (progressData) {
          console.log(progressData)
          const { percent } = progressData
          if (percent < 1) {
            Toast.loading({
              message: '上传中...',
              forbidClick: true,
              duration: 0
            })
          } else {
            Toast.clear()
          }
        }
      },
      function (err, data) {
        data ? resolve(data) : reject(err)
        console.log(err)
        console.log(data)
      }
    )
  })
}

export const validatePhone = (phone: any) => {
  const reg_tel =
    /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
  if (!reg_tel.test(phone)) {
    Toast('请输入正确的手机号')
    return Promise.reject()
  }
  return Promise.resolve()
}

export const TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
